import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro'
import React from 'react'
import { CheckboxProps } from 'src/components/VirtualCardsBox/VirtualCardsBox'
import { VirtualCardsFiltersBody } from 'src/components/VirtualCardsBoxAndLinks/VirtualCardsBoxAndLinks'
import VirtualCardsDataGrid from 'src/components/VirtualCardsDataGrid/VirtualCardsDataGrid'
import { VirtualCardListModel } from 'src/models/virtualCard.models'
import { VirtualCardPermissions } from 'src/models/virtualCardPermissions.models'
import { InfiniteScrollProps } from 'src/types'

interface VirtualCardsTableProps {
  virtualCards: VirtualCardListModel[]
  virtualCardsPermissions?: Array<{
    permissions: VirtualCardPermissions[]
    virtualCardId: string
  }>
  sortableProps?: {
    setSort: (field: string) => void
    sortBy?: string
    sortDescending?: boolean
  }
  isYourCards: boolean
  checkboxProps?: CheckboxProps
  infiniteScrollProps?: InfiniteScrollProps<VirtualCardsFiltersBody>
  filtersBody?: VirtualCardsFiltersBody
  clientHeight?: number
}

const VirtualCardsTable: React.FC<VirtualCardsTableProps> = (props) => {
  const defaultColumnVisibilityModel: GridColumnVisibilityModel = {
    cardName: true,
    cardUser: true,
    cardType: true,
    status: true,
    activeUntil: true,
    availableCredit: true,
  }

  return (
    <VirtualCardsDataGrid
      sortableProps={props.sortableProps}
      virtualCards={props.virtualCards}
      virtualCardsPermissions={props.virtualCardsPermissions}
      isYourCards={props.isYourCards}
      checkboxProps={props.checkboxProps}
      infiniteScrollProps={props.infiniteScrollProps}
      filters={props.filtersBody}
      clientHeight={props.clientHeight}
      defaultColumnVisibilityModel={defaultColumnVisibilityModel}
    />
  )
}

export default VirtualCardsTable
